import axiosInstance from "../../lib/axios";

export async function getPropDropDown() {
  try {
    return await axiosInstance.post("PropertyMst/getPropertyMstdrp");
  } catch (error) {
    return error;
  }
}

//Generate prop ,Wing,floor wise room
export async function getMstPropRoomConfig(payload) {
  try {
    return await axiosInstance.post(
      "MstPropFloorConfig/GetMstPropRoomConfigDashBoard",
      payload
    );
  } catch (error) {
    return error;
  }
}



//Generate beds
export async function manageMstPropFloorConfig(payload) {
  try {
    return await axiosInstance.post(
      "MstPropFloorConfig/GetMstPropRoomBedConfigDashBoard",
      payload
    );
  } catch (error) {
    return error;
  }
}

//Generate room
export async function manageMstPropRoomConfig(payload) {
  try {
    return await axiosInstance.post(
      "MstPropFloorConfig/ManageMstPropRoomConfig",
      payload
    );
  } catch (error) {
    return error;
  }
}

//wing drp
export async function getMstWingdrp(propId, flag = "F") {
  try {
    return await axiosInstance.post("WingMst/getMstWingdrp", {
      Flag: flag,
      Strwhere: propId,
    });
  } catch (error) {
    return error;
  }
}

//Floor drp
export async function getFloorMstdrp(propId, flag = "F") {
  try {
    return await axiosInstance.post("FloorMst/getFloorMstdrp", {
      Flag: flag,
      Strwhere: propId,
    });
  } catch (error) {
    return error;
  }
}
//room Type drp
export async function getdrpRoomTypeMst() {
  try {
    return await axiosInstance.post("RoomTypeMst/getdrpRoomTypeMst");
  } catch (error) {
    return error;
  }
}

// Table Get APi ,RoomMst ,Generate tabledashboard api,

export async function getRoomMaster(payload) {
  try {
    return await axiosInstance.post("RoomMst/getAllRoomMstDashBoard", payload);
  } catch (error) {
    return error;
  }
}

//Insert RoomMst
export async function insertRoomMst(formData) {
  try {
    return await axiosInstance.post("RoomMst/InsertRoomMst", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    return error;
  }
}

//RoomMst/UpdateRoomMst
export async function updateRoomMst(formData) {
  try {
    return await axiosInstance.post("RoomMst/UpdateRoomMst", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    return error;
  }
}

//RoomMst/RetriveRoomMst   Flag P,N,L,D
export async function getRoomMst(payload) {
  try {
    return await axiosInstance.post("RoomMst/RetriveRoomMst", payload);
  } catch (error) {
    return error;
  }
}

//Form Two functions

export async function getdrpFacilitiesMst() {
  try {
    return await axiosInstance.post("RoomFacLink/getdrpFacilitiesMst");
  } catch (error) {
    return error;
  }
}

export async function insertRoomFacLink(payload) {
  try {
    return await axiosInstance.post("RoomFacLink/InsertRoomFacLink", payload);
  } catch (error) {
    return error;
  }
}

export async function UpdateRoomFacLink(payload) {
  try {
    return await axiosInstance.post("/RoomFacLink/UpdateRoomFacLink", payload);
  } catch (error) {
    return error;
  }
}

export async function retriveRoomFacLink(payload) {
  try {
    return await axiosInstance.post("RoomFacLink/RetriveRoomFacLink", payload);
  } catch (error) {
    return error;
  }
}
//insert and update both
export async function ManageRoomFacLink(payload) {
  try {
    return await axiosInstance.post("RoomFacLink/ManageRoomFacLink", payload);
  } catch (error) {
    return error;
  }
}
//RoomMst/getdrpRoomView
export async function getdrpRoomView() {
  try {
    return await axiosInstance.post("RoomMst/getdrpRoomView");
  } catch (error) {
    return error;
  }
}
//RoomMst/ManageRoomUpdation
export async function manageRoomUpdation(payload) {
  try {
    return await axiosInstance.post("RoomMst/ManageRoomUpdation", payload);
  } catch (error) {
    return error;
  }
}
// Api for Bed Master
export async function getAllRoomBedMstDashBoard(payload) {
  try {
    return await axiosInstance.post(
      "RoomBedMst/getAllRoomBedMstDashBoard",
      payload
    );
  } catch (error) {
    return error;
  }
}
//RoomBedMst/RetriveRoomBedMst
export async function retriveRoomBedMst(payload) {
  try {
    return await axiosInstance.post("RoomBedMst/RetriveRoomBedMst", payload);
  } catch (error) {
    return error;
  }
}
//RoomBedMst/InsertRoomBedMst
export async function insertRoomBedMst(payload) {
  try {
    return await axiosInstance.post("RoomBedMst/InsertRoomBedMst", payload);
  } catch (error) {
    return error;
  }
}
//
export async function updateRoomBedMst(payload) {
  try {
    return await axiosInstance.post("RoomBedMst/UpdateRoomBedMst", payload);
  } catch (error) {
    return error;
  }
}
//RoomMst/getdrpRoomMst
export async function getdrpRoomMst(payload) {
  try {
    return await axiosInstance.post("RoomMst/getdrpRoomMst", payload);
  } catch (error) {
    return error;
  }
}
///MstPropFloorConfig/GetMstPropRoomBedConfigDashBoard
export async function getMstPropRoomBedConfigDashBoard(PropId) {
  try {
    return await axiosInstance.post(
      "MstPropFloorConfig/GetMstPropRoomBedConfigDashBoard",
      {
        PropId: PropId,
      }
    );
  } catch (error) {
    return error;
  }
}
//user wise property data
export async function getPropertyMstUserwisedrp(payload) {
  try {
    return await axiosInstance.post(
      "PropertyMst/GetPropertyMstUserwisedrp",
      payload
    );
  } catch (error) {
    return error;
  }
}
//Delete  bed data updation
export async function deleteManageBedUpdation(payload) {
  try {
    return await axiosInstance.post("RoomBedMst/ManageBedUpdation", payload);
  } catch (error) {
    return error;
  }
}

//Bed Type Drp
export async function getdrpBedTypeMst() {
  try {
    return await axiosInstance.post("RoomBedTypeMst/getdrpBedTypeMst");
  } catch (error) {
    return error;
  }
}

//Bed data updation
export async function manageBedUpdation(payload) {
  try {
    return await axiosInstance.post("RoomBedMst/ManageBedUpdation", payload)
  } catch (error) {
    return error;
  }
}


